import { personal_details } from '@flows/configs/shared/steps/personal_details'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import cross_breed_names from './cross_breed_names'
import living_environment from './living_environment'
import pet_age from './pet_age'
import pet_birthday from './pet_birthday'
import pet_chip_number from './pet_chip_number'
import pet_chipped from './pet_chipped'
import pet_conditions from './pet_conditions'
import pet_gender from './pet_gender'
import pet_insurance_cancelled from './pet_insurance_cancelled'
import pet_name from './pet_name'
import pet_neutered from './pet_neutered'
import pet_owner_birthday from './pet_owner_birthday'
import pet_previous_insurance from './pet_previous_insurance'
import pet_previous_insurer from './pet_previous_insurer'
import pet_quote from './pet_quote'
import pet_treatment from './pet_treatment'
import pet_type from './pet_type'
import pure_breed from './pure_breed'
import pure_breed_name from './pure_breed_name'
import shoulder_height from './shoulder_height'

const getPetHealthSteps = (params: StepConfigParams) =>
  ({
    pet_name: pet_name(params),
    pet_type: pet_type(params),
    pure_breed: pure_breed(params),
    cross_breed_names: cross_breed_names(params),
    pure_breed_name: pure_breed_name(params),
    shoulder_height: shoulder_height(params),
    pet_birthday: pet_birthday(params),
    pet_age: pet_age(params),
    living_environment: living_environment(params),
    pet_owner_birthday: pet_owner_birthday(params),
    pet_quote: pet_quote(params),
    pet_chipped: pet_chipped(params),
    pet_chip_number: pet_chip_number(params),
    pet_gender: pet_gender(params),
    pet_neutered: pet_neutered(params),
    pet_previous_insurance: pet_previous_insurance(params),
    pet_previous_insurer: pet_previous_insurer(params),
    pet_insurance_cancelled: pet_insurance_cancelled(params),
    pet_treatment: pet_treatment(params),
    pet_conditions: pet_conditions(params),
    pet_health_personal_details: personal_details(params, {
      nextStep: 'gender',
      omitFields: ['birthdate'],
      translations: {
        title: 'sharedFlows_common:steps.personal_details.title',
        birthdateLabel: 'sharedFlows_common:steps.personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_common:steps.email_and_name.checkboxes.marketingOptIn',
        minAgeError: 'sharedFlows_common:generic.errors.min_age',
        maxAgeError: 'sharedFlows_common:generic.errors.max_age',
      },
      policyPreviewConsent: {
        titleKey: 'sharedFlows_petHealth:steps.personal_details.policyPreview.title',
        textKey: 'sharedFlows_petHealth:steps.personal_details.policyPreview.text',
      },
    }),
  }) as const satisfies AnySteps

export default getPetHealthSteps
